const BASE_URL = "http://157.122.13.48:8088/iot-api";

const BASE_URL_Category = {
	queryToken: BASE_URL + "/api/queryToken", //token
	// 园区总览
	devices_overview: BASE_URL + "/devices/stat/overview", //设备分布统计
	area_overview: BASE_URL + `/devices/area-overview`, //重点区域
	factor_trend: BASE_URL + `/devices/factor-trend`, //设备因子数值趋势
	level_trend: BASE_URL + `/warn/stat/level-trend`, //告警等级次数趋势
	page_warn_list: BASE_URL + `/warn/page-warn-list`, //重点告警
	deal_warn: BASE_URL + `/warn/deal-warn`, //重点告警-处理
	camera_list: BASE_URL + `/camera/list`, //视频监控
	latDataCode: BASE_URL + `/devices/latest-data`, //设备最新数据：
	devSetings: BASE_URL + `/devices/settings`, //算法配置获取
	// 设备管理
	management_overview: BASE_URL + `/devices/management/overview`, //设备概览
	device_maintenance: BASE_URL + `/work-order/device-maintenance/overview`, //维保管理
	get_work_order: BASE_URL + `/work-order/get-work-order`, //维保管理-查看详情
	edit_work_order: BASE_URL + `/work-order/edit-work-order`, //维保管理-生成计划
	remote_maintenance: BASE_URL + `/devices/remote-management/overview`, //右侧远程管理
	command_records: BASE_URL + `/devices/command-records/recent`, //最近设备操作记录
	commands: BASE_URL + `/devices/commands`, //设备命令下发
	// 事件告警
	event_overview: BASE_URL + `/warn/stat/event-overview`, //事件全览
	get_warn_detail: BASE_URL + `/warn/get-warn-detail`, //事件告警详情
	page_handle_record_list: BASE_URL + `/warn/page-handle-record-list`, //最近事件操作记录
	// 视频管理
	camera_overview: BASE_URL + `/camera/overview`, //事件告警详情
	control: BASE_URL + `/camera/ptz/control`, //云台与镜头控制
	analyze_image: BASE_URL + `/camera/ai/analyze-image`, //智能分析当前画面
	ai_chat_stream: BASE_URL + `/ai/assistant/chat/stream`, //AI 问答（SSE 流式）
};

export default {
	BASE_URL_Category
};